import type { BadgeKanbanStageStatusColor } from '@shared/ui/kanban'

/** Discipline kanban stage colors, as the legacy `LabelKanbanStage` drew them; unlisted stages are gray. */
export const DISCIPLINE_STAGE_COLOR: Record<string, BadgeKanbanStageStatusColor> = {
  MANUAL_ACTIVATION: 'blue',
  IN_PROGRESS: 'blue',
  NEGOTIATIONS: 'blue',
  NEW_BILLING_REQUESTS: 'blue',
  UPGRADE_DOWNGRADE: 'blue',
  NEW_PURCHASE: 'emerald',
  LEARNING: 'emerald',
  CLOSED_WON: 'emerald',
  REFUND: 'red',
  DISPUTE: 'red',
  CANCELED: 'red',
  CLOSED_LOST: 'red',
  BAD_FEEDBACK: 'red',
  HEALTHCHECK: 'amber',
  CONTACT_NEEDED: 'amber',
  WAITING_FOR_PAYMENT: 'amber',
  BILLING_ISSUES: 'orange',
  FAIL_PAYMENT: 'orange',
  SUPPORT_ISSUES: 'orange',
  TUTOR_INCIDENTS: 'orange',
  SERVICE_REQUESTS: 'orange',
  LESSONS_CATCH_UP: 'pink',
  ACTIVATION: 'pink',
  SEMI_ACTIVATION: 'indigo',
}
